import axios from "axios";
import {SERVER} from "../../Constants"

// API call to fetch pending photo verifications
const apiClient = axios.create({
    baseURL: SERVER,
    withCredentials: true
});

export const sendOTPVerification = async (requestType) => {
    console.log("RequestType: ", requestType)
    try {
        const response = await apiClient
            .post('/user/sendValidationToken',  { requestType });
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};


export const disableAccount = async (token) => {
    try {
        const response = await apiClient
            .post('/user/disableUserAccount',  { token });
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};

export const deleteAccount = async (token) => {
    try {
        const response = await apiClient
            .post('/user/deleteUserAccount',  { token });
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};


export const getPendingPhotoVerifications = async () => {
    try {
        const response = await apiClient.get('/user/getPendingPhotoVerifications');
        console.log("API response getPendingPhotoVerifications:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};


export const verifyUser= async (verificationId) => {
    try {
        const response = await apiClient.post('/user/acceptPhotoVerification', {verificationId});
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};

export const denyUserVerification = async (verificationId) => {
    try {
        const response = await apiClient.post('/user/denyPhotoVerification', {verificationId});
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};

export const disableUser = async (userId) => {
    try {
        const response = await apiClient.post('/user/blockAccount', {userId});
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};

export const enableUser = async (userId) => {
    try {
        const response = await apiClient.post('/user/unblockAccount', {userId});
        console.log("API response:", response); // Debugging log
        return response.data;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};

export const getMarkedForDeletion = async () => {
    try {
        const response = await apiClient.get('/manager/markedForDeletion');
        console.log("API response getMarkedForDeletion:", response); // Debugging log
        return response.data.users;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
};

export const deleteAccountPermanently = async (userId, permanent = true) => {
    try {
        const response = await apiClient.post('/manager/deleteAccount', 
            new URLSearchParams({ userId, permanent: permanent.toString() }),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
        console.log("API response deleteAccountPermanently:", response); // Debugging log
        return response.data.deletedData;
    } catch (error) {
        console.error("API error:", error.response); // Debugging log
        throw new Error(error.response?.data?.message || 'Failed to delete account');
    }
};
